var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('Horizontal-menu',{staticClass:"horiMenu",attrs:{"page":_vm.route}}),_c('CentersMap',{attrs:{"covid":_vm.covidData,"insuline":_vm.insulineData,"pni":_vm.pniData,"serum":_vm.serumData,"loader":_vm.loaderStatus}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }